import React, { Component } from "react";
import { BsyUtils } from "../../../utils/Utils";
import "./index.css";
export default class BsyDashRecentUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      block: props.block,
    };
  }
  componentDidMount() {
    if (this.state.mode === "edit") {
      this.props.onGetRecentUseValue();
    }
    this.props?.onRefreshChars?.();
  }

  render() {
    return (
      <div className="recent-use-page">
        {this.state.mode === "edit" && (
          <div className="edit-type">
            <span>无需统一配置，系统自动展示各成员最近访问的表单/报表</span>
          </div>
        )}
        {this.state.mode === "visit" && this.props.recentUse.list.length === 0 && (
          <div className="edit-type no-data">
            <span>暂无最近访问的表单/报表</span>
          </div>
        )}
        {this.state.mode !== "edit" && (
          <div className="recent-use-entry">
            <div className="use-entry-box">
              {this.props.recentUse.list.map((data) => {
                return (
                  <a className="entry-item" href={"/team/app/" + data.appId + "/" + data.type + "/" + data.entryId}>
                    <div className="item-cont">
                      {(data.type === "form" ||
                        data.type === "report" ||
                        data.type === "dash" ||
                        data.type === "scenes") && (
                          <>
                            <i
                              className={
                                "entry-icon " + BsyUtils.getFormIcon(data)
                              }
                            />
                            <span className={"entry-title"}>
                              {data.customName || data.name || data.appname}
                            </span>
                          </>
                        )}
                      {(data.type === "app" ||
                        data.type === "url" ||
                        data.type === "system") && (
                          <>
                            <div
                              className={
                                "app-icon color-cover-" + data.style.color
                              }
                            >
                              <div
                                className={
                                  "imgbg-bsy-app imgbg-bsy-app-" + data.style.icon
                                }
                              />
                            </div>
                            <span className="app-name">
                              {data.customName || data.appname || data.name}
                            </span>
                          </>
                        )}
                      {data.type === "image" && (
                        <>
                          <div
                            className={`img-bg`}
                            style={{
                              backgroundImage: `url(${data.imageUrl})`,
                              backgroundSize: "100%",
                            }}
                          ></div>
                          <span className="app-name">
                            {data.customName || data.appname || data.name}
                          </span>
                        </>
                      )}
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}
